export const MAX_LOCAL_FILE_SIZE_MB = 20;

export function isLocalFileSizeValid(file: File) {
  return file.size <= MAX_LOCAL_FILE_SIZE_MB * 1024 * 1024;
}
